import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import classNames from 'classnames';

import { Menubar } from 'primereact/menubar';
import { Menu } from 'primereact/menu';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';

import { AccountService } from '../service/AccountService';

import { BreadcrumbsService } from './AppBreadCrumb';
import { ToastService } from '../AppToast';
import { AppConfig } from './AppConfig';
import { ROLE } from '../Constant';

export const AppTopbar = (props) => {
  const { permissions } = props;
  const op = useRef(null);
  const menu = useRef(null);

  const location = useLocation();

  const [submitting, setSubmitting] = useState(false);

  const [displayChangePassword, setDisplayChangePassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [appUserMenus, setAppUserMenus] = useState([]);

  const template = (item, options) => {
    if (item.target) {
      return (
        <NavLink to={item.target} className={options.className}>
          <span className={options.iconClassName} />
          <span className={options.labelClassName}>{item.label}</span>
        </NavLink>
      );
    } else {
      return (
        <a href="/" className={options.className} target={item.target} onClick={options.onClick}>
          <span className={options.iconClassName} />
          <span className={options.labelClassName}>{item.label}</span>
        </a>
      );
    }
  };

  const appMenus: Array<any> = [
    {
      label: 'Đăng ký phát hành',
      icon: 'fa-solid fa-file-circle-check',
      className: 'app-menu-20',
      items: [
        { label: 'Mẫu hóa đơn', role: ROLE.REGISTER_INVOICE, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/phat-hanh/mau-hoa-don', template },
        { label: 'Lập tờ khai', role: ROLE.DECLARE_REGISTER_INVOICE, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/phat-hanh/to-khai-dang-ky', template },
      ],
    },
    { label: 'Hoá đơn đầu ra', role: ROLE.INVOICE_MANAGEMENT, parentRole: true, icon: 'fa-solid fa-file-invoice-dollar', target: '/hoa-don', template },
    {
      label: 'Xử lý sai sót',
      icon: 'fa-solid fa-file-circle-exclamation',
      className: 'app-menu-25',
      items: [
        { label: 'Hủy hóa đơn', role: ROLE.ERROR_MANAGEMENT_INVOICECANCEL, icon: 'pi pi-fw pi-circle', target: '/xu-ly-sai-sot/huy-hoa-don', template },
        { label: 'Thay thế hóa đơn', role: ROLE.ERROR_MANAGEMENT_INVOICE_SUBSTITUDE, icon: 'pi pi-fw pi-circle', target: '/xu-ly-sai-sot/thay-the-hoa-don', template },
        { label: 'Điều chỉnh hóa đơn', role: ROLE.ERROR_MANAGEMENT_INVOICE_ADJUSTMENT, icon: 'pi pi-fw pi-circle', target: '/xu-ly-sai-sot/dieu-chinh-hoa-don', template },
        { label: 'Thay thế HĐ trên hệ thống khác', role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_SUBSTITUDE, icon: 'pi pi-fw pi-circle', target: '/xu-ly-sai-sot/thay-the-hoa-don-tren-he-thong-khac', template },
        { label: 'Điều chỉnh HĐ trên hệ thống khác', role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_ADJUSTMENT, icon: 'pi pi-fw pi-circle', target: '/xu-ly-sai-sot/dieu-chinh-hoa-don-tren-he-thong-khac', template },
        { label: 'Thông báo HĐ sai sót 04/SS-HĐĐT', role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_WRONG_INVOICE, icon: 'pi pi-fw pi-circle', target: '/xu-ly-sai-sot/thong-bao-04-ss-hddt', template },
      ],
    },
    {
      label: 'Lịch sử truyền nhận',
      icon: 'pi pi-sort-alt',
      className: 'app-menu-20',
      items: [
        { label: 'Tờ khai đăng ký', role: ROLE.MGATEWAY_DECLARE, icon: 'pi pi-fw pi-circle', target: '/lich-su-truyen-nhan/to-khai-dang-ky', template },
        { label: 'Hóa đơn', role: ROLE.MGATEWAY_INVOICE, icon: 'pi pi-fw pi-circle', target: '/lich-su-truyen-nhan/hoa-don', template },
        { label: 'Thông báo sai sót', role: ROLE.MGATEWAY_WRONG_INVOICE, icon: 'pi pi-fw pi-circle', target: '/lich-su-truyen-nhan/thong-bao-sai-sot', template },
        { label: 'Bảng tổng hợp', role: ROLE.MGATEWAY_INVOICE_SUMMARY, icon: 'pi pi-fw pi-circle', target: '/lich-su-truyen-nhan/bang-tong-hop', template },
        { label: 'Thanh toán QRCode', role: ROLE.MGATEWAY_INVOICE_SUMMARY, icon: 'pi pi-fw pi-circle', target: '/lich-su-truyen-nhan/thanh-toan-qr', template },

      ],
    },
    {
      label: 'Báo cáo',
      icon: 'pi pi-fw pi-chart-line',
      className: 'app-menu-25',
      items: [
        { label: 'Báo cáo tình hình sử dụng hóa đơn', role: ROLE.REPORT_SUMMARY, icon: 'pi pi-fw pi-circle', target: '/bao-cao/tinh-hinh-su-dung', template },
        { label: 'Báo cáo tổng hợp hóa đơn', role: ROLE.REPORT_SUMMARY, icon: 'pi pi-fw pi-circle', target: '/bao-cao/tong-hop-hoa-don', template },
        { label: 'Báo cáo chi tiết hóa đơn', role: ROLE.REPORT_DETAIL, icon: 'pi pi-fw pi-circle', target: '/bao-cao/chi-tiet-hoa-don', template },
        { label: 'Báo cáo nhận vào PMKT', role: ROLE.REPORT_PMKT, icon: 'pi pi-fw pi-circle', target: '/bao-cao/nhan-pmkt', template },
        { label: 'Báo cáo PL101/2023/QH15', role: ROLE.REPORT_PLQH, icon: 'pi pi-fw pi-circle', target: '/bao-cao/pl43-2022-qh15', template },
        { label: 'Báo cáo bảng kê bán ra (PL01)', role: ROLE.REPORT_PLQH01, icon: 'pi pi-fw pi-circle', target: '/bao-cao/phu-luc-01', template },
        { label: 'Lập bảng tổng hợp mẫu 01/TH-HĐĐT', role: ROLE.REPORT_SUMMARY01, icon: 'pi pi-fw pi-circle', target: '/bao-cao/tong-hop-mau-01', template },
        { label: 'Kiểm tra trạng thái MST', role: ROLE.INVOICE_MANAGEMENT, icon: 'pi pi-fw pi-circle', target: '/bao-cao/trang-thai-mst', template },
        { label: 'Báo cáo xăng dầu mẫu thuế', role: ROLE.REPORT_SUMMARY, icon: 'pi pi-fw pi-circle', target: '/bao-cao/tong-hop-hoa-don-xang-dau', template },
      ],
    },
    {
      label: 'Danh mục',
      icon: 'pi pi-fw pi-th-large',
      className: 'app-menu-20',
      items: [
        { label: 'Khách hàng', role: ROLE.CATEGORY_TENANT_CLIENT, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/danh-muc/khach-hang', template },
        { label: 'Hàng hóa, dịch vụ', role: ROLE.CATEGORY_PRODUCT, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/danh-muc/hang-hoa-dich-vu', template },
        { label: 'Đơn vị tính', role: ROLE.CATEGORY_UNIT, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/danh-muc/don-vi-tinh', template },
        { label: 'Tiền tệ', role: ROLE.CATEGORY_CURRENCY, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/danh-muc/tien-te', template },
        { label: 'Mẫu Email', role: ROLE.CATEGORY_EMAIL_TEMPLATE, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/danh-muc/mau-email', template },
        { label: 'Thuế suất', role: ROLE.CATEGORY_TAX, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/danh-muc/thue-suat', template },
        { label: 'Hình thức thanh toán', role: ROLE.CATEGORY_PAYMENT_TYPE, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/danh-muc/ht-thanh-toan', template },
        { label: 'Ngân hàng', role: ROLE.CATEGORY_PAYMENT_TYPE, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/danh-muc/ngan-hang-thu-huong', template },
        {
          label: 'Quản lý xăng dầu',
          role: [ROLE.CATEGORY_PRODUCT, ROLE.CATEGORY_TENANT_CLIENT],
          icon: 'pi pi-fw pi-angle-down',
        },
        { label: 'Cửa hàng xăng dầu', role: ROLE.CATEGORY_PRODUCT, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/danh-muc/cua-hang-xang-dau', template },
        { label: 'Mặt hàng xăng dầu', role: ROLE.CATEGORY_PRODUCT, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/danh-muc/hang-hoa-xang-dau', template },
        { label: 'Vòi bơm', role: ROLE.CATEGORY_PRODUCT, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/danh-muc/thiet-bi', template },
        { label: 'Danh mục thiết bị tích hợp', role: ROLE.CATEGORY_PRODUCT, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/danh-muc/thiet-bi-tich-hop', template },
        { label: 'Danh sách giao dịch xăng dầu', role: ROLE.CATEGORY_PRODUCT, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/danh-muc/danh-sach-giao-dich-xang-dau', template },
        { label: 'Cấu hình tạo hóa đơn xăng dầu', role: ROLE.SYSTEM_EMAILING, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/he-thong/cau-hinh-dong-bo-hoa-don-xang-dau', template },
      ],
    },
    {
      label: 'Cấu hình',
      icon: 'pi pi-fw pi-cog',
      className: 'app-menu-20',
      items: [{ label: 'Nhóm quyền', role: ROLE.USER_MANAGEMENT_SYSTEM_ROLES, icon: 'pi pi-fw pi-circle', target: '/cau-hinh/nhom-quyen', template }],
    },
    {
      label: 'Hệ thống',
      icon: 'pi pi-fw pi-cog',
      className: 'app-menu-20',
      items: [
        {
          label: 'Quản lý doanh nghiệp',
          role: [ROLE.COMPANY_MANAGEMENT_INFO, ROLE.COMPANY_MANAGEMENT_LICENSE],
          icon: 'pi pi-fw pi-angle-down',
        },
        { label: 'Thông tin doanh nghiệp', role: ROLE.COMPANY_MANAGEMENT_INFO, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/he-thong/doanh-nghiep/thong-tin-doanh-nghiep', template },
        { label: 'Bản quyền', role: ROLE.COMPANY_MANAGEMENT_LICENSE, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/he-thong/doanh-nghiep/ban-quyen', template },
        {
          label: 'Quản lý người dùng',
          role: [ROLE.USER_MANAGEMENT_ROLES, ROLE.USER_MANAGEMENT_USERS],
          icon: 'pi pi-fw pi-angle-down',
        },
        { label: 'Nhóm quyền', role: ROLE.USER_MANAGEMENT_ROLES, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/he-thong/nguoi-dung/nhom-quyen', template },
        { label: 'Người sử dụng', role: ROLE.USER_MANAGEMENT_USERS, icon: 'pi pi-fw pi-minus', className: 'pl-3', target: '/he-thong/nguoi-dung/nguoi-su-dung', template },
        { label: 'Đăng ký chứng thư số', role: ROLE.SYSTEM_TOKEN_MANAGEMENT, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/he-thong/chung-thu-so', template },
        { label: 'Khai báo tham số hệ thống', role: ROLE.SYSTEM_TENANT_SETTING, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/he-thong/tham-so-he-thong', template },
        { label: 'Cấu hình hoá đơn', role: ROLE.SYSTEM_CONFIG_INVOICE, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/he-thong/cau-hinh-hoa-don', template },
        { label: 'Cấu hình email server', role: ROLE.SYSTEM_EMAILING, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/he-thong/cau-hinh-email-server', template },
        { label: 'Giá trị thay thế', role: ROLE.SYSTEM_VALUE_REPLACES, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/he-thong/gia-tri-thay-the', template },
        { label: 'Giá trị mặc định', role: ROLE.SYSTEM_VALUE_DEFAULT, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/he-thong/gia-tri-mac-dinh', template },
        { label: 'Quản trị - Quản lý mẫu hóa đơn', role: ROLE.SYSTEM_INVOICE_TEMPLATE, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/admin/mau-hoa-don', template },
        // {label: 'Cấu hình email TB MTT cần ký', role: ROLE.SYSTEM_EMAILING, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/he-thong/cau-hinh-email-tb-mtt', template},

      ],
    },
  ];

  const logout = () => {
    window.location.hash = '/login';
  };

  const accountMenus = [{ label: props.user.name, icon: 'pi pi-fw pi-user' }, { label: 'Đổi mật khẩu', icon: 'pi pi-fw pi-key', command: () => setDisplayChangePassword(true) }, { separator: true }, { label: 'Đăng xuất', icon: 'pi pi-fw pi-sign-out', command: logout }];

  const setMenuDescriptionRecursive = (menu) => {
    menu.recursiveLabels.push(menu);
    if (menu.items) {
      menu.items.forEach((item) => {
        item.recursiveLabels = [...menu.recursiveLabels];
        setMenuDescriptionRecursive(item);
      });
    }
  };

  const getMenuDescriptionRecursive = (pathname, menu) => {
    let recursiveLabels;
    if (pathname === menu.target) {
      recursiveLabels = menu.recursiveLabels;
    } else if (pathname === `${menu.target}/create` || pathname.includes(`${menu.target}/create/`)) {
      recursiveLabels = menu.recursiveLabels;
      recursiveLabels.push({ label: 'Tạo mới' });
    } else if (pathname.includes(`${menu.target}/detail/`)) {
      recursiveLabels = menu.recursiveLabels;
      recursiveLabels.push({ label: 'Chi tiết' });
    } else if (pathname.includes(`${menu.target}/update/`)) {
      recursiveLabels = menu.recursiveLabels;
      recursiveLabels.push({ label: 'Chỉnh sửa' });
    }

    if (!recursiveLabels && menu.items) {
      for (const item of menu.items) {
        recursiveLabels = getMenuDescriptionRecursive(pathname, item);
        if (recursiveLabels) {
          break;
        }
      }
    }
    return recursiveLabels;
  };

  const getMenuDescription = (menus) => {
    let recursiveLabels;
    for (const menu of menus) {
      recursiveLabels = getMenuDescriptionRecursive(location.pathname, menu);
      if (recursiveLabels) {
        break;
      }
    }
    if (recursiveLabels) {
      const breadcrumbs = [];
      recursiveLabels.forEach(({ label, target }) => {
        const breadcrumb: any = { label };
        if (target) {
          breadcrumb.command = () => {
            window.location.hash = target;
          };
        }
        breadcrumbs.push(breadcrumb);
      });
      BreadcrumbsService.setBreadcrumbs(breadcrumbs);
    }
  };

  const recurGenMenu = async (curNode, menu) => {
    if (!menu.items || menu.items.length == 0) {
      if (curNode.role) {
        if (Array.isArray(curNode.role)) {
          for (const role of curNode.role) {
            if ((permissions.indexOf(role) >= 0 && !curNode.parentRole) || (permissions.filter((t) => t.includes(role)).length && curNode.parentRole)) {
              return curNode;
            }
          }
        } else {
          if ((permissions.indexOf(curNode.role) >= 0 && !curNode.parentRole) || (permissions.filter((t) => t.includes(curNode.role)).length && curNode.parentRole)) {
            return curNode;
          }
        }
      }
      return null;
    } else {
      curNode.items = [];
      for (let i = 0; i < menu.items.length; i++) {
        let nextNode = JSON.parse(JSON.stringify(menu.items[i]));
        nextNode.template = menu.items[i].template;
        let child = await recurGenMenu(nextNode, menu.items[i]);
        if (child) {
          curNode.items.push(child);
        }
      }
      return curNode.items.length > 0 ? curNode : null;
    }
  };

  useEffect(() => {
    new Promise((resolve) => {
      let data = { items: appMenus };
      let clearMenu = [];
      let menu = recurGenMenu(clearMenu, data);
      resolve(menu);
    }).then((data: any) => {
      let menu = data && data.items ? data.items : [];
      menu.forEach((m) => {
        m.recursiveLabels = [];
        setMenuDescriptionRecursive(m);
      });
      setAppUserMenus(menu);
      getMenuDescription(menu);
    });
  }, [permissions, location]);

  const downloadPlugin = () => {
    const link = document.createElement('a');
    link.href = `https://plugin.minvoice.com.vn/MinvoicePlugin_NewApp/setup.exe`;
    link.click();

    const linkHelp = document.createElement('a');
    linkHelp.href = `https://www.youtube.com/watch?v=F6DglkasLP0&t=33s`;
    linkHelp.target = '_blank';
    linkHelp.click();
  };

  useEffect(() => { }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const changePassword = (event) => {
    if (!submitting) {
      setSubmitting(true);

      if (newPassword?.includes(' ')) {
        ToastService.error('Mật khẩu không hợp lệ!');
        setSubmitting(false);
      } else if (newPassword === newPasswordConfirm) {
        AccountService.changePassword({
          currentPassword,
          newPassword,
          newPasswordConfirm,
        })
          .then(() => {
            setDisplayChangePassword(false);
            ToastService.success();
            logout();
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        ToastService.error('Mật khẩu nhập lại không chính xác');
        setSubmitting(false);
      }
    }
    event.preventDefault();
  };

  return (
    <div className="layout-topbar">
      <Link to="/" className="layout-topbar-logo">
        <img src={'assets/layout/images/LogoAppMinvoice_new.png'} alt="logo" />
      </Link>

      <Menubar model={appUserMenus} className="app-menu" />
      <ul className={classNames('layout-topbar-menu lg:flex origin-top')}>
        <li>
          <a href={'https://youtube.com/playlist?list=PLpmokHjV2pDoVYFzvpovlXwnB7OVkbm8H'} rel="noreferrer" target="_blank">
            <button className="p-link layout-topbar-button">
              <i className="pi pi-youtube" />
              <span>Guide</span>
            </button>
          </a>
        </li>
        <li>
          <button className="p-link layout-topbar-button" onClick={downloadPlugin}>
            <i className="pi pi-download" title="Tải M-invoice Plugin" />
            <span>Download</span>
          </button>
        </li>
        <li>
          <button className="p-link layout-topbar-button" onClick={(e) => op.current.toggle(e)}>
            <i className="pi pi-bell" />
            <span>Notifications</span>
          </button>
          <OverlayPanel ref={op} style={{ width: '450px' }}>
            <div className="grid notification">
              <div className="col-3">
                <div className="notification-icon">
                  <i className="fa-solid fa-bullhorn"></i>
                </div>
              </div>
              <div className="col-9">
                <p>
                  <b>Kính mời quý khách hàng đọc ấn phẩm Thông tin chuyển đổi số 04</b>
                </p>
                <p>02/06/2022</p>
              </div>
            </div>
            <div className="grid notification mt-2">
              <div className="col-3">
                <div className="notification-icon">
                  <i className="fa-solid fa-bullhorn"></i>
                </div>
              </div>
              <div className="col-9">
                <p>
                  <b>Kính mời quý khách hàng đọc ấn phẩm Thông tin chuyển đổi số 04</b>
                </p>
                <p>02/06/2022</p>
              </div>
            </div>
            <div className="grid notification mt-2">
              <div className="col-3">
                <div className="notification-icon">
                  <i className="fa-solid fa-bullhorn"></i>
                </div>
              </div>
              <div className="col-9">
                <p>
                  <b>Kính mời quý khách hàng đọc ấn phẩm Thông tin chuyển đổi số 04</b>
                </p>
                <p>02/06/2022</p>
              </div>
            </div>
          </OverlayPanel>
        </li>
        <li style={{ display: 'none' }}>
          <AppConfig {...props} />
        </li>
        <li>
          <button className="p-link layout-topbar-button" onClick={(event) => menu.current.toggle(event)}>
            <i className="pi pi-user" />
            <span>Profile</span>
          </button>
          <Menu model={accountMenus} popup ref={menu} />
        </li>
      </ul>
      <Dialog header="Đổi mật khẩu" visible={displayChangePassword} style={{ width: '500px' }} position="top" onHide={() => setDisplayChangePassword(false)}>
        <form onSubmit={changePassword}>
          <div className="p-fluid formgrid grid">
            <div className="field col-12 md:col-12">
              <label htmlFor="currentPassword">Mật khẩu hiện tại</label>
              <Password value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} toggleMask feedback={false} required />
            </div>
            <div className="field col-12 md:col-12">
              <label htmlFor="newPassword">Mật khẩu mới</label>
              <Password value={newPassword} onChange={(e) => setNewPassword(e.target.value)} toggleMask required />
            </div>
            <div className="field col-12 md:col-12">
              <label htmlFor="newPasswordConfirm">Xác nhận mật khẩu mới</label>
              <Password value={newPasswordConfirm} onChange={(e) => setNewPasswordConfirm(e.target.value)} toggleMask feedback={false} required />
            </div>
          </div>

          <div className="flex justify-content-end mt-2">
            <Button label="Đổi mật khẩu" icon="pi pi-check" className="p-button-sm" loading={submitting} />
          </div>
        </form>
      </Dialog>
    </div>
  );
};
